module.exports = __webpack_public_path__ + "img/swiper3.61b225d4.png";